var map = {
	"./1.jpg": 6442,
	"./team1.jpg": 8671,
	"./team12.jpg": 8365,
	"./team2.jpg": 1296,
	"./team3.jpg": 6189,
	"./team4.jpg": 9990,
	"./team5.jpg": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2660;